export default "__VITE_ASSET__Dtg4rJlk__"